import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ContentProvider } from './context/ContentContext.tsx'
import { PublicDesignProvider } from './context/design.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ContentProvider>
      <PublicDesignProvider>
        <App />
      </PublicDesignProvider>
    </ContentProvider>
  </StrictMode>,
)
